import * as types from "./ReportsActionType";

const initialState = {
    userLogReportData: {},
    prePostGnReportData: [],
    prePostACReportData: [],
    bookingTypeList: [],
    reportGenAiData: []
}
const ReportsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.USER_LOG_REPORT_DATA:
            return {
                ...state,
                userLogReportData: [...action.payload]
            }
        case types.PREPOND_POSTPOND_GNREPORT:
            return {
                ...state,
                prePostGnReportData: action.payload
            }
        case types.PREPOND_POSTPOND_ACREPORT:
            return {
                ...state,
                prePostACReportData: action.payload
            }
        case types.UPDATE_BOOKING_TYPE: {
            return {
                ...state,
                bookingTypeList: action.payload
            }
        }
        case types.UPDATE_GENAI_REPORT: {
            return {
                ...state,
                reportGenAiData: action.payload
            }
        }
        //
        default:
            return state;
    }
}
export default ReportsReducer;